var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.3066 9.73328H20.6933C14.1066 9.73328 8.77332 15.0933 8.77332 21.6533V46.7466C8.77332 53.3066 14.1333 58.6666 20.6933 58.6666H43.28C49.8666 58.6666 55.2 53.3066 55.2 46.7466V21.6533C55.2266 15.0666 49.8666 9.73328 43.3066 9.73328Z",
    fill: "#BA4A14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2667 5.33337H25.7334C22.96 5.33337 20.6934 7.57337 20.6934 10.3467V12.8534C20.6934 15.6267 22.9334 17.8667 25.7067 17.8667H38.2667C41.04 17.8667 43.28 15.6267 43.28 12.8534V10.3467C43.3067 7.57337 41.04 5.33337 38.2667 5.33337Z",
    fill: "#BA4A14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34.5333H21.3333C20.24 34.5333 19.3333 33.6267 19.3333 32.5333C19.3333 31.44 20.24 30.5333 21.3333 30.5333H40C41.0933 30.5333 42 31.44 42 32.5333C42 33.6267 41.0933 34.5333 40 34.5333Z",
    fill: "#BA4A14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0133 45.2H21.3333C20.24 45.2 19.3333 44.2933 19.3333 43.2C19.3333 42.1066 20.24 41.2 21.3333 41.2H33.0133C34.1066 41.2 35.0133 42.1066 35.0133 43.2C35.0133 44.2933 34.1066 45.2 33.0133 45.2Z",
    fill: "#BA4A14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardText);
export default __webpack_public_path__ + "static/media/clipboard-text.cf8750cfd9e94f88de0001bfcb079218.svg";
export { ForwardRef as ReactComponent };